export type PriceBookLayout = 'by-sheet' | 'sections' | 'flat';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function selectPriceBookLayout(rows: readonly unknown[] | undefined, previewValueBinding: string | undefined): PriceBookLayout {
  const list = Array.isArray(rows) ? rows : [];
  const records = list.filter(isRecord);
  if (records.some((row) => typeof row.sheet_id === 'string' && row.sheet_id.length > 0)) return 'by-sheet';
  if (previewValueBinding === 'unbound') return 'sections';
  return 'flat';
}
